var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrderCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177,
    height: 176,
    viewBox: "0 0 177 176",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.907 71.4869L123.907 71.487L123.913 71.4809C126.224 69.0904 126.232 65.3316 123.907 63.0065C121.585 60.6845 117.748 60.6845 115.427 63.0065L78.0867 100.346L61.5736 83.8331C59.2517 81.5112 55.4151 81.5112 53.0932 83.8331C50.7713 86.1551 50.7713 89.9916 53.0932 92.3136L73.8465 113.067C74.9659 114.186 76.486 114.827 78.0867 114.827C79.6875 114.827 81.2076 114.186 82.327 113.067L123.907 71.4869ZM15.6667 88C15.6667 47.8695 48.3696 15.1667 88.5001 15.1667C128.631 15.1667 161.333 47.8695 161.333 88C161.333 128.131 128.631 160.833 88.5001 160.833C48.3696 160.833 15.6667 128.131 15.6667 88Z",
    fill: "#494949",
    stroke: "#494949"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderCompleted);
export default __webpack_public_path__ + "static/media/order_completed.49a55f60f8cad38422496940187fa834.svg";
export { ForwardRef as ReactComponent };